// Shared title derivation for memories. Used by feed cards, detail sheet, and
// any future surface that renders a memory title (export, share card, etc.).
//
// Returns the user-set title if present, otherwise a short excerpt from
// ai_chapter / raw_transcript, otherwise null. Callers supply their own
// final fallback copy (it differs by surface: "A memory" / "A Shortie" /
// "Untitled" / "Memory saved on {date}").

interface TitleSource {
  title?: string | null;
  ai_chapter?: string | null;
  raw_transcript?: string | null;
}

const AUTO_TITLE_WORDS = 6;

export function getMemoryAutoTitle(memory: TitleSource): string | null {
  const source = memory.ai_chapter || memory.raw_transcript || "";
  const trimmed = source.trim();
  if (!trimmed) return null;
  const words = trimmed.split(/\s+/);
  const head = words.slice(0, AUTO_TITLE_WORDS).join(" ");
  return words.length > AUTO_TITLE_WORDS ? head + "…" : head;
}

export function getMemoryDisplayTitle(memory: TitleSource): string | null {
  if (memory.title && memory.title.trim()) return memory.title;
  return getMemoryAutoTitle(memory);
}
